export const TYPE_WEB_ALL = 1;
export const TYPE_API_DECODE_VEHICLE_DETAILS = 2;
export const TYPE_API_LEGAL_CHECK = 3;
export const TYPE_API_LEASING_CHECK = 4;
export const TYPE_API_DECODE_BASIC = 5;
export const TYPE_VEHICLE_REPORT = 6;
export const TYPE_API_STOLEN_CHECK = 7;
export const TYPE_API_VEHICLE_MARKET_VALUE = 9;
export const TYPE_SERVICE_DATA_PROCESSING = 8;
export const TYPE_API_OEM_VIN_LOOKUP = 10;
export const MAX_AMOUNT = 999999;
